export { default } from './AlternativeProductsTableRoute'
